// extracted by mini-css-extract-plugin
export var icn_text = "icontext-module--icn_text--C1ZA+";
export var icon_layout = "icontext-module--icon_layout--e3shG";
export var icon_wrapper = "icontext-module--icon_wrapper--r7-R3";